/* eslint-disable no-nested-ternary */
import React, { useRef, useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  IconButton,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch } from 'react-redux';
import { TP_COLORS } from './constants';
import { reportIssue } from './store/V2/ReportIssueSlice';

const ReportIssue = () => {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState<string>('');
  const buttonRef = useRef<HTMLDivElement | null>(null);

  const theme = useTheme();
  const belowSmScreen = useMediaQuery(theme.breakpoints.only('sm'));
  const belowMd = useMediaQuery(theme.breakpoints.down('md'));

  const dispatch = useDispatch();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = async () => {
    const issueData = {
      reason,
      reference: window.location.href,
    };
    dispatch(reportIssue(issueData));
    handleClose();
  };

  return (
    <>
      <Box
        sx={{
          position: 'fixed',
          top: '45%',
          right: 0,
          zIndex: 1000,
          padding: '2px',
          backgroundColor: TP_COLORS.blue.dark,
          color: 'white',
          borderRadius: '0 10px 10px 0',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
          writingMode: 'vertical-rl',
          textAlign: 'center',
          height: '150px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transform: 'rotate(-180deg)',
        }}
      >
        <Box sx={{ width: '18px', height: '18px', ml: '5px', mb: '10px' }}>
          <WarningAmberRoundedIcon
            sx={{
              transform: 'rotate(90deg)',
              width: '100%',
              height: '100%',
            }}
          />
        </Box>
        <Button
          variant="text"
          color="inherit"
          onClick={handleClickOpen}
          sx={{
            color: 'white',
            textTransform: 'none',
            fontSize: '16px',
            padding: 0,
            minWidth: 'auto',
            fontWeight: 500,
          }}
        >
          Report issue
        </Button>
      </Box>

      {/* Modal Dialog */}
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            position: 'absolute',
            top: buttonRef.current
              ? buttonRef.current.getBoundingClientRect().top - 70
              : '70%',
            right: buttonRef.current
              ? window.innerWidth -
                buttonRef.current.getBoundingClientRect().left +
                10
              : '20px',
            transform: 'translateY(-50%)',
            m: 0,
            width: belowSmScreen ? '50%' : belowMd ? '80%' : 'auto',
            height: 'auto',
            borderRadius: '15px',
          },
        }}
      >
        <DialogTitle
          sx={{ fontWeight: 'bold', fontSize: '1.05rem', marginRight: '20px' }}
        >
          Report an issue / Missing Something?
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" gutterBottom sx={{ pb: '10px' }}>
            Having trouble or missing something? Please let us know!
          </Typography>
          <TextField
            autoFocus
            margin="dense"
            id="reason"
            label="Reason*"
            type="text"
            fullWidth
            multiline
            rows={5}
            variant="outlined"
            placeholder="Type here..."
            sx={{ mb: '-10px' }}
            onChange={(event) => setReason(event.currentTarget.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ margin: '14px 14px' }}
            disabled={reason.length < 4}
            onClick={handleSubmit}
            variant="contained"
            color="primary"
          >
            Send
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ReportIssue;
